document.addEventListener('DOMContentLoaded', () => {
  const closeGroups = except => document.querySelectorAll('.ss-nav-group[open]').forEach(group => { if (group !== except) group.open = false; });
  document.addEventListener('click', event => { if (!event.target.closest('.ss-navigation')) closeGroups(); });
  document.querySelectorAll('.ss-nav-group').forEach(group => group.addEventListener('toggle', () => { if (group.open) closeGroups(group); }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const group = document.activeElement.closest('.ss-nav-group[open]');
    if (group) { group.open = false; group.querySelector('summary').focus(); }
  });
  const skip = document.querySelector('.ss-skip');
  if (skip) skip.addEventListener('click', () => document.getElementById('MainContent').focus());
});

// Mobile shopping dialog accessibility
(() => {
  const start = () => {
    const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const focusable = panel => [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex="0"]')].filter(visible);
    const dialogs = [];
    const closeFacets = (trigger, event) => {
      const drawer = trigger.closest('menu-drawer.mobile-facets__wrapper');
      const details = drawer?.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary || typeof drawer.closeMenuDrawer !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      details.querySelectorAll('summary').forEach(item => item.setAttribute('aria-expanded', 'false'));
      drawer.closeMenuDrawer(event, summary);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-ss-facets-apply], .mobile-facets__close[role="button"]');
      if (trigger) closeFacets(trigger, event);
    }, true);
    const connect = ({panel, target, open, triggers, close, first, bodyClass}) => {
      if (!panel || !target) return;
      let wasOpen = false;
      let returnFocus = null;
      triggers.forEach(trigger => trigger.addEventListener('click', () => { returnFocus = trigger; }));
      const sync = () => {
        const isOpen = open();
        panel.inert = !isOpen;
        panel.setAttribute('aria-hidden', String(!isOpen));
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(isOpen)));
        if (bodyClass) document.body.classList.toggle(bodyClass, isOpen);
        if (isOpen && !wasOpen) {
          if (!returnFocus && visible(document.activeElement)) returnFocus = document.activeElement;
          requestAnimationFrame(() => { if (open()) (first() || focusable(panel)[0] || panel).focus({preventScroll:true}); });
        }
        if (!isOpen && wasOpen) {
          const restore = returnFocus;
          returnFocus = null;
          if (visible(restore)) requestAnimationFrame(() => restore.focus({preventScroll:true}));
        }
        wasOpen = isOpen;
      };
      panel.addEventListener('transitionend', event => {
        if (event.target === panel && open() && !panel.contains(document.activeElement)) {
          (first() || focusable(panel)[0] || panel).focus({preventScroll:true});
        }
      });
      new MutationObserver(sync).observe(target, {attributes:true,attributeFilter:['class']});
      sync();
      dialogs.push({panel,open,close});
    };
    const nav = document.getElementById('NavDrawer');
    connect({panel:nav,target:document.body,open:() => document.body.classList.contains('js-drawer-open-left'),triggers:[...document.querySelectorAll('button.js-drawer-open-left')],close:() => nav.querySelector('.drawer__close-button')?.click(),first:() => nav.querySelector('.drawer__close-button')});
    const search = document.querySelector('.detail-modal');
    const searchPanel = search?.querySelector('.search-modal');
    const mobileSearch = document.querySelector('.modal__toggle-search-mobile');
    const desktopSearch = document.querySelector('.header__icon--search');
    if (desktopSearch && !desktopSearch.matches('button,a')) {
      desktopSearch.tabIndex = 0;
      desktopSearch.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        desktopSearch.querySelector('.modal__toggle-open')?.click();
      });
    }
    connect({panel:searchPanel,target:search,open:() => search.classList.contains('active'),triggers:[mobileSearch,desktopSearch].filter(Boolean),close:() => search.querySelector('.search-modal__close-button')?.click(),first:() => search.querySelector('input[type="search"]'),bodyClass:'ss-search-open'});
    document.querySelectorAll('.js-mini-cart').forEach(cart => {
      if (document.body.classList.contains('template-cart')) return;
      const trigger = cart.querySelector('.js-toggle-cart');
      connect({panel:cart.querySelector('.mini-cart-content'),target:cart,open:() => cart.classList.contains('active'),triggers:[trigger].filter(Boolean),close:() => (cart.querySelector('.mini-cart-header .close') || trigger)?.click(),first:() => cart.querySelector('.mini-cart-header .close'),bodyClass:'ss-cart-open'});
    });
    document.addEventListener('keydown', event => {
      const dialog = [...dialogs].reverse().find(item => item.open() && item.panel.contains(document.activeElement));
      if (dialog) {
        if (event.key === 'Escape') {
          event.preventDefault();
          dialog.close();
          return;
        }
        if (event.key === 'Tab') {
          const items = focusable(dialog.panel);
          const first = items[0], last = items[items.length-1];
          if (!first) { event.preventDefault(); dialog.panel.focus(); }
          else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }
      const filterClose = event.target.closest('.mobile-facets__close[role="button"]');
      if (filterClose && (event.key === 'Enter' || event.key === ' ')) {
        closeFacets(filterClose, event);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
